import React from 'react'
import './Banner.css'


const Banner = () =>{
return (
    <div className = "banner">
        <img src = '/Image/fondo.png' alt= 'Foto Banner'/>
    </div>
    )
}
export default Banner